export const BACKEND_URLS = Object({
  "PROD": "https://go.inhousedelivery.com",
  "DEMO": "https://demo-api.inhousedelivery.cloud",
  "LOCAL": "https://pg-2.opensimsim.cloud",
  "PG-1": "https://pg-1.opensimsim.cloud",
  "PG-2": "https://pg-2.opensimsim.cloud",
  "PG-3": "https://pg-3.opensimsim.cloud",
  "PG-4": "https://pg-4.opensimsim.cloud",
  "PG-5": "https://pg-5.opensimsim.cloud",
  "PG-6": "https://pg-6.opensimsim.cloud",
  "PG-7": "https://pg-7.opensimsim.cloud",
  "PG-8": "https://pg-8.opensimsim.cloud",
});